import {fragments} from '@/gql';
const {gql} = require('graphql-tag');
export default gql`
  mutation createFilmToPerson($input: FilmToPersonInput!) {
    createFilmToPerson(input: $input) {
      ...filmRelationships
      filmID
      personID
      professionID
      id
      Profession {
        ...profession
      }
    }
  }
  ${fragments.filmRelationships}
  ${fragments.companyNames}
  ${fragments.companyNameDetail}
  ${fragments.relationshipTypeDetail}
  ${fragments.profession}
  ${fragments.companyDepartmentDetail}
  ${fragments.companyTypeTree}
  ${fragments.companyType}
`;
